import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { ARROW_LABEL } from './PropertyRow.constants';
import { arrowStyles, propertyRowStyles, valueRowStyles } from './PropertyRow.styles';

const PropertyRow = ({ propertyName, oldValue, newValue }) => (
  <Box sx={propertyRowStyles}>
    <Typography color="text.secondary" variant="medium12">
      {propertyName}
    </Typography>
    <Box sx={valueRowStyles}>
      <Typography color="text.primary" variant="regular12">
        {oldValue ?? '—'}
      </Typography>
      <Typography color="text.secondary" sx={arrowStyles} variant="regular12">
        {ARROW_LABEL}
      </Typography>
      <Typography color="text.primary" variant="regular12">
        {newValue ?? '—'}
      </Typography>
    </Box>
  </Box>
);

PropertyRow.propTypes = {
  propertyName: PropTypes.string.isRequired,
  newValue: PropTypes.string,
  oldValue: PropTypes.string,
};

export default memo(PropertyRow);
